<ion-content>
  <ion-row class="ion-justify-content-end">
    <ion-button class="close" fill="clear" shape="round" (click)="close()">Cerrar</ion-button>
  </ion-row>
  <ion-row>
    <img src="{{ product.product.pictureUrl }}" />
    <div class="pattern-wrapper">
      <div>
        <b class="title-se">
          {{ product.product.title }}
        </b>
      </div>
      <div *ngIf="initialQty != 0">
        <span>
          {{ recipeQty == 1 ? recipeQty + ' Unidad' : recipeQty + ' Unidades' }}
        </span>
      </div>
      <div>
        <span>
          {{ product.product.unitPrice.amt | currency: product.product.unitPrice.cur }}
        </span>
      </div>
    </div>
  </ion-row>

  <ion-row class="show-se note" style="padding: 0 10px">
    {{ product.product.description }}
  </ion-row>

  <!-- WALLETBONUS EXCEPTION -->
  <div *ngIf="product?.product.type == productType.WALLETBONUS" class="line-space hide-se"></div>

  <div class="wallet-info hide-se" *ngIf="product?.product.type == productType.WALLETBONUS">
    <div class="boxed-details hide-se" *ngFor="let descriptionLine of product.product.descriptionLines">
      <div class="line-show hide-se">
        <img [src]="descriptionLine.icon" class="hide-se" />
        {{ descriptionLine.label }}
      </div>
    </div>
  </div>
  <div *ngIf="product?.product.type == productType.WALLETBONUS" class="line-space hide-se"></div>

  <ion-row class="ion-justify-content-center ion-align-items-center">
    <ion-button size="large" fill="clear" (click)="removeButton()">
      <ion-icon name="remove-circle-outline"></ion-icon>
    </ion-button>

    <p>{{ recipeQty }}</p>

    <ion-button size="large" fill="clear" (click)="addButton()">
      <ion-icon name="add-circle-outline"></ion-icon>
    </ion-button>
  </ion-row>

  <div class="spacing">
    <ion-button *ngIf="initialQty != 0" expand="block" fill="clear" shape="round" (click)="deleteModal()">
      Eliminar
    </ion-button>
  </div>

  <ion-button disabled="{{ recipeQty == 0 }}" expand="block" (click)="submit()">
    {{
      initialQty == 0
        ? ' Añadir al carrito ' + (product.product.unitPrice.amt * recipeQty | currency: product.price.cur) + ' '
        : ' Continuar '
    }}
  </ion-button>
</ion-content>
